import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const AlarmCheck = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 12 12"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M10.875 8.248h.375a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1 0-1.5h.375a3.263 3.263 0 0 0 1.125-2.25v-2.25A3.713 3.713 0 0 1 6-.002c.238.002.476.025.71.07a3.739 3.739 0 0 0 3.04 5.93c.06.87.464 1.68 1.125 2.25zM6 11.998a1.5 1.5 0 0 1-1.5-1.5h3a1.5 1.5 0 0 1-1.5 1.5z"
        fill="#0FA862"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M12.002.928 8.906 4.025 7.125 2.244l.93-.93.85.85 2.167-2.166.93.93z"
        fill="#0FA862"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};

AlarmCheck.displayName = 'AlarmCheck';
